export default "__VITE_ASSET__ed3213bc__"